import styled from 'styled-components';
import Colors from 'assets/Colors';
import Constants from 'helpers/constants';

const StoreContainer = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_secondary};
  position: absolute;
  left: 235px;
  height: 58px;
  display: flex;
  align-items: center;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    position: unset;
    padding-right: 18px;
  }
`;

const Wrapper = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export default {
  StoreContainer,
  Wrapper,
};
